<script lang="ts">
  import cn from "classnames";
  import { createEventDispatcher } from "svelte";

  export let options: { value: string; name: string }[] = [];

  export let value = "";

  const dispatch = createEventDispatcher<{
    change: { value: string };
  }>();

  function onChange() {
    dispatch("change", { value });
  }
</script>

<select
  class={cn("form-select", $$props.class)}
  bind:value
  on:change={onChange}
  {...$$restProps}
>
  {#each options as { value, name }}
    <option {value} selected={value === options[0].value}>
      {name}
    </option>
  {/each}
</select>
